<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>THE THIRTEENTH</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<link href="../page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<p class="linespace"><a id="page_ii"></a></p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="right-para">ALSO BY L. A. BANKS</p>
<p class="linespace"> </p>
<p class="right-para"><span class="small">VAMPIRE HUNTRESS LEGENDS</span></p>
<p class="right-para"><em>Minion<br/>The Awakening<br/>The Hunted<br/>The Bitten<br/>The Forbidden<br/>The Damned<br/>The Forsaken<br/>The Wicked<br/>The Cursed<br/>The Darkness<br/>The Shadows</em></p>
<p class="linespace"> </p>
<p class="right-para"><span class="small">CRIMSON MOON NOVELS</span><br/><em>Bad Blood<br/>Bite the Bullet</em></p>
<p class="linespace"> </p>
<p class="right-para"><span class="small">ANTHOLOGIES</span><br/><em>Love at First Bite<br/>Stroke of Midnight</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?3ebf5d88